import { render, staticRenderFns } from "./imageUploadAndShow.vue?vue&type=template&id=0562b866&"
import script from "./imageUploadAndShow.vue?vue&type=script&lang=js&"
export * from "./imageUploadAndShow.vue?vue&type=script&lang=js&"
import style0 from "./imageUploadAndShow.vue?vue&type=style&index=0&id=0562b866&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports